<kiwi-parameters-header [title]="'parameters.title'|translate" [i18nKey]="[{target: 'attribute:title', key: 'parameters.title'}]"></kiwi-parameters-header>

<kiwi-spacer [size]="32"></kiwi-spacer>

<div class="cell auto grid-x grid-margin-x align-stretch">
    <kiwi-parameters-menu class="cell shrink blockContent"></kiwi-parameters-menu>
    <div class="cell auto grid-y">
        <router-outlet></router-outlet>
    </div>
</div>
